export const validBlogLink = value => {
  if (typeof value !== 'string' || Array.from(value.trim()).some(char => char.charCodeAt(0) <= 32 || char.charCodeAt(0) === 92)) return false;
  try { const url = new URL(value.trim(), 'https://bookishcircle.com'); return ['http:', 'https:', 'mailto:'].includes(url.protocol) && !url.username && !url.password; } catch { return false; }
};
const EXTERNAL_LINK_REL = "noopener noreferrer";

const getDefaultOrigin = () => {
  if (typeof window === "undefined" || !window.location?.origin) {
    return "";
  }

  return window.location.origin;
};

export const isInternalBlogLink = (href, currentOrigin = getDefaultOrigin()) => {
  const normalizedHref = href?.trim();

  if (!normalizedHref) {
    return true;
  }

  if (normalizedHref.startsWith("//")) return false;
  if (
    normalizedHref.startsWith("/") ||
    normalizedHref.startsWith("?") ||
    normalizedHref.startsWith("#") ||
    normalizedHref.startsWith("./") ||
    normalizedHref.startsWith("../")
  ) {
    return true;
  }

  if (normalizedHref.startsWith("//")) {
    return false;
  }

  try {
    const resolvedUrl = new URL(normalizedHref, currentOrigin || undefined);

    if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(normalizedHref)) {
      return true;
    }

    return Boolean(currentOrigin) && resolvedUrl.origin === currentOrigin;
  } catch (error) {
    return !/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(normalizedHref);
  }
};

export const getAnchorAttributesForHref = (href, currentOrigin = getDefaultOrigin()) => {
  const normalizedHref = href?.trim() || "";

  if (!normalizedHref || !validBlogLink(normalizedHref)) {
    return {};
  }

  if (isInternalBlogLink(normalizedHref, currentOrigin)) {
    return { href: normalizedHref };
  }

  return {
    href: normalizedHref,
    target: "_blank",
    rel: EXTERNAL_LINK_REL,
  };
};

export const normalizeBlogContentHtml = (html, currentOrigin = getDefaultOrigin()) => {
  if (!html || typeof DOMParser === "undefined") {
    return html || "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("a[href]").forEach((anchor) => {
    const href = anchor.getAttribute("href") || "";
    const anchorAttributes = getAnchorAttributesForHref(href, currentOrigin);

    if (!anchorAttributes.href) { anchor.removeAttribute("href"); anchor.removeAttribute("target"); anchor.removeAttribute("rel"); return; }
    anchor.setAttribute("href", anchorAttributes.href);

    if (anchorAttributes.target) {
      anchor.setAttribute("target", anchorAttributes.target);
      anchor.setAttribute("rel", anchorAttributes.rel);
      return;
    }

    anchor.removeAttribute("target");
    anchor.removeAttribute("rel");
  });

  return doc.body.innerHTML;
};

